import List from 'containers/ExperienceLevels/List';
import Edit from 'containers/ExperienceLevels/Edit';
import Create from 'containers/ExperienceLevels/Create';
import Show from 'containers/ExperienceLevels/Show';

export default { List, Edit, Create, Show };
